import { connect } from 'react-redux';
import React, { ReactElement, Suspense } from 'react';
import { IntStore } from '../../schemas/store.interface';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { getCompany } from '../../core/session-storage/session-storage.service';
import { environment } from '../../environments/environment';
import {initRefund}from '../../schemas/refund.interface'
import { getCodeCompany } from '../user/user.service';
const Refund = (props: initRefund): ReactElement => {

  const { t } = useTranslation();
  const companyStorage = getCompany();

  const history = useHistory();
  const goBack = () => {
    history.goBack()
  }

  const vlg_rlink = t(`${companyStorage}.refund.link_url`);
  const def_rlink = `${environment.static.pdfs}/${companyStorage}/${props.user.language}/reembolso_${getCodeCompany(companyStorage)}.pdf`;

  const ibe_contact_rlink = t(`iberia.refund.link_contacto_url`);
  const ibe_claims_rlink = t(`iberia.refund.link_reclamaciones_url`);

  const isIberia = getCodeCompany(companyStorage) === 'IBE';

  return (
    <Suspense fallback="">
      <div className="card">
        {t(`${companyStorage}.refund.title`)}
        {isIberia ? (
          <div style={{ display: 'block', marginBottom: '6px' }}>
            <a href={ibe_contact_rlink} target="_blank" rel="noopener noreferrer" style={{ display: 'block', marginBottom: '4px' }}>
              {t(`iberia.refund.link_contacto_lbl`)}<span className="sr-only"> {t('A11Y_NUEVA_VENTANA')}</span>
            </a>
            <a href={ibe_claims_rlink} target="_blank" rel="noopener noreferrer" style={{ display: 'block' }}>
              {t(`iberia.refund.link_reclamaciones_lbl`)}<span className="sr-only"> {t('A11Y_NUEVA_VENTANA')}</span>
            </a>
          </div>
        ) : (
          <a href={def_rlink} target="_blank" rel="noopener noreferrer">
          {t(`${companyStorage}.refund.link`)}<span className="sr-only"> {t('A11Y_NUEVA_VENTANA')}</span>
          </a>
        )}
        <div className="btn-wrapper">
          <button data-qa="submit-pir" className="btn btn--primary" id="btn-user-continue" onClick={goBack}>{t('DEFAULT_BTN_VOLVER')}</button>
        </div>
      </div>
  </Suspense>
  );
};

const mapStateToProps = (state: IntStore) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Refund);
